<div
  class="d-flex flex-column align-items-center justify-content-center text-center py-10"
>
  <img
    [src]="
      imagePath ||
      'https://developmentcontent.blob.core.windows.net/resources/application/NO-Data.png'
    "
    [style.height]="imageHeight ? imageHeight : '230px'"
    alt="No Data"
    class="mb-2"
  />

  <span class="text-gray-900 text-md font-semibold">
    {{ title }}
  </span>

  <span class="text-gray-700 text-sm">
    {{ description }}
  </span>
</div>
